import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Trash2, Plus } from "lucide-react";

export function TemplatesDialog({ open, onOpenChange }) {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["late-templates"], queryFn: async () => (await api.get("/late-donors/templates")).data.templates, enabled: open });
  const [list, setList] = useState([]);
  useEffect(() => { if (open && data) setList(data); }, [open, data]);
  const upd = (i, patch) => setList((l) => l.map((t, j) => (j === i ? { ...t, ...patch } : t)));

  async function save() {
    if (list.some((t) => !t.name?.trim() || !t.body?.trim())) return toast.error("Ogni messaggio deve avere un nome e un testo");
    try {
      await api.put("/late-donors/templates", { templates: list });
      qc.invalidateQueries({ queryKey: ["late-templates"] }); toast.success("Template salvati"); onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Controlla nome e testo"); }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-white max-h-[90dvh] overflow-y-auto" data-testid="late-templates-dialog">
        <DialogHeader><DialogTitle>Messaggi preimpostati</DialogTitle></DialogHeader>
        <div className="text-[12px] text-stone-500">Segnaposto: {"{nome} {mesi} {ultima_data} {ultimo_importo} {impegno} {frequenza}"}</div>
        <div className="space-y-4">
          {list.map((t, i) => (
            <div key={t.id || i} className="border border-stone-200 rounded-lg p-3 space-y-2" data-testid={`late-tpl-${i}`}>
              <div className="flex gap-2">
                <Input value={t.name} onChange={(e) => upd(i, { name: e.target.value })} placeholder="Nome template" data-testid={`late-tpl-name-${i}`}/>
                <select value={t.channel} onChange={(e) => upd(i, { channel: e.target.value })} className="border border-stone-200 rounded-md px-2 text-sm">
                  <option value="whatsapp">WhatsApp</option><option value="email">Email</option>
                </select>
                <button onClick={() => setList(list.filter((_, j) => j !== i))} className="text-stone-400 hover:text-red-600 px-1"><Trash2 size={15}/></button>
              </div>
              {t.channel === "email" && <Input value={t.subject} onChange={(e) => upd(i, { subject: e.target.value })} placeholder="Oggetto"/>}
              <Textarea rows={4} value={t.body} onChange={(e) => upd(i, { body: e.target.value })}/>
            </div>
          ))}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => setList([...list, { name: "Nuovo messaggio", channel: "whatsapp", subject: "", body: "Ciao {nome}, " }])} data-testid="late-tpl-add"><Plus size={14} className="mr-1"/> Aggiungi</Button>
          <Button onClick={save} className="bg-[#1C352D] hover:bg-[#264A3E]" data-testid="late-tpl-save">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
